module.exports = __webpack_public_path__ + "static/img/blog_2.a760620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog_2.jpg
// module id = DR0a
// module chunks = 0